import './ForwardedHeader.css';
import { FaMessengerIcon } from '@/components/ui/Icons';

interface ForwardedHeaderProps {
  senderName: string;
  isOwn: boolean;
}

export function ForwardedHeader({ senderName, isOwn }: ForwardedHeaderProps) {
  return (
    <div className={`forwardedHeader ${isOwn ? 'forwardedHeader_own' : 'forwardedHeader_peer'}`}>
      <FaMessengerIcon icon="share" size={14} className="forwardedHeader__icon" />
      <span className="forwardedHeader__text">
        Переслано от <strong>{senderName}</strong>
      </span>
    </div>
  );
}
